import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export const getViewCreateSuccessAlert = ({
  name
}) => {
  return {
    'data-test-id': 'create-view-success-alert',
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "manageViews.alerts.createView.success.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "manageViews.alerts.createView.success.message",
      options: {
        name
      }
    }),
    type: 'success'
  };
};
export const getViewEditSuccessAlert = ({
  name
}) => {
  return {
    'data-test-id': 'edit-view-success-alert',
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "manageViews.alerts.updateView.success.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "manageViews.alerts.updateView.success.message",
      options: {
        name
      }
    }),
    type: 'success'
  };
};
export const getGoToCreatedTaskAlert = ({
  name,
  linkProps
}) => {
  return {
    type: 'success',
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "taskForm.success.title"
    }),
    message: /*#__PURE__*/_jsx("span", {
      "data-test-id": "go-to-created-task-alert-message",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "taskForm.success.message_jsx",
        options: {
          name,
          linkProps
        },
        elements: {
          Link: UILink
        }
      })
    })
  };
};